<template>
    <navBar title="Ares - Purchase partners" :home="true" type="pp"/>
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }
</script>
